import { render } from "./otp.vue?vue&type=template&id=4fb09744"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__